<template>
  <form-item-facade
    class="range-picker-item"
    :errors="errors"  
    :name="name"
    :rules="rules"
  >
    <range-picker-facade
      v-model="model"
      :disabled="disabled"
      :disabled-date="disabledDate"
      :placeholder="placeholder"
      @calendar-change="(dates, dateStrings, info) => $emit('calendar-change', dates, dateStrings, info)"
      @open-change="(status) => $emit('open-change', status)"
    />
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import FormItemFacade from '@/lib/ant-design-vue/components/FormItemFacade.vue';
  import RangePickerFacade from '@/lib/ant-design-vue/components/RangePickerFacade.vue';

  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Отключено ли поле ввода даты
    disabled: {
      type: Boolean,
      default: false,
    },

    // Specify the date that cannot be selected
    disabledDate: {
      type: Function,
      default: () => false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // The placeholder of date input
    placeholder: Array,

    // Правила валидации поля.
    rules: Object,
  });

  defineEmits(['calendar-change', 'open-change']);
</script>

<style lang="scss" scoped>

</style>